export const copyPasteActions = {
  SET_COPY_PASTE_DATA: 'SET_COPY_PASTE_DATA',
  SET_ERROR_LINES: 'SET_ERROR_LINES',
  RESET_ERRORS: 'RESET_ERRORS',
};

export const initialState = {
  copyPasteData: [],
  errorLines: {
    specialChar: [],
    newLine: [],
    format: [],
  },
  errorMessages: {
    specialChar:
      'Please ensure your list doesn’t contain any special characters e.g. !, @, #, £',
    newLine: 'Please ensure each entry is on a new line',
    format: 'Please ensure each entry is separated by a comma e.g. product,qty',
  },
};

export const copyPasteReducer = (state, action) => {
  const updatedState = { ...state };

  switch (action.type) {
    case copyPasteActions.SET_COPY_PASTE_DATA:
      updatedState.errorLines = { specialChar: [], newLine: [], format: [] };
      updatedState.copyPasteData = action.payload;
      break;
    case copyPasteActions.SET_ERROR_LINES:
      Object.keys(action.payload).forEach(key => {
        updatedState.errorLines[key] = action.payload[key];
      });
      break;
    case copyPasteActions.RESET_ERRORS:
      updatedState.errorLines = { specialChar: [], newLine: [], format: [] };
      break;
    default:
      // eslint-disable-next-line no-console
      console.error('Reducer type not found:', action.type);
  }

  return updatedState;
};
